import { useEffect } from 'react';
import { useFormik } from 'formik';

import { InitialCausality } from '../../../../../../shared/types/typifications/initialCausality';

export const useInitialCausalityRegisterHistory = (
    initialCausality?: InitialCausality
) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy } = initialCausality || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : '',
        });
    }, [initialCausality]);

    return {
        formik,
    };
};
